import { create } from 'zustand';
const useOgrafOutput = create(() => ({
    graphics: [],
    error: null,
}));
const reactiveOutput = {
    useGraphics: () => {
        return useOgrafOutput((s) => s.graphics);
    },
    useError: () => {
        return useOgrafOutput((s) => s.error);
    },
};
export class OgrafServiceOutput {
    static getReactiveOutput() {
        return reactiveOutput;
    }
    getGraphics() {
        return useOgrafOutput.getState().graphics;
    }
    addGraphic(entry) {
        useOgrafOutput.setState((s) => ({
            graphics: [...s.graphics, entry],
        }));
    }
    removeGraphic(id) {
        useOgrafOutput.setState((s) => ({
            graphics: s.graphics.filter((g) => g.id !== id),
        }));
    }
    updateGraphicState(id, state, currentStep) {
        useOgrafOutput.setState((s) => ({
            graphics: s.graphics.map((g) => g.id === id ? { ...g, state, currentStep } : g),
        }));
    }
    setError(error) {
        useOgrafOutput.setState({ error });
    }
}
